import React, {ReactElement} from 'react';
import {Container, Grid, Box, Typography} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
// import expertaBAImage from 'images/logged/experta_BA.jpg';

function ErrorView(): ReactElement {
  const {t} = useTranslation(['common']);
  return (
    <Container maxWidth="md" disableGutters>
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md={6}>
          <Box mt={6} px={2}>
            <Typography align="center" variant="h3">
              {t('common:errorPage.title')}
            </Typography>
            <Typography paragraph align="center" variant="h2">
              {t('common:errorPage.subtitle')}
            </Typography>
            <Typography align="center">{t('common:errorPage.text')}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ErrorView;
